import React from 'react';
import classNames from '../../utils/classNames';
import { UseFormRegister } from 'react-hook-form';

interface ComponentProps {
  label: string | JSX.Element;
  value?: boolean;
  setValue?: (v: boolean) => void;
  disabled?: boolean;
  register?: UseFormRegister<any>;
  name?: string;
  labelClasses?: string;
  labelStyle?: React.CSSProperties;
  className?: string;
  required?: boolean
}

const CheckboxWithLabel = ({
  label,
  value,
  setValue,
  disabled,
  register,
  name,
  labelClasses,
  labelStyle,
  className,
  required = false,
}: ComponentProps) => {
  const id = name || (typeof label === 'string' ? label : '');

  // Determine if the component should be controlled or uncontrolled
  const isControlled = value !== undefined && setValue !== undefined;

  // Build the input props based on controlled/uncontrolled mode
  const inputProps = {
    id,
    'aria-describedby': `${id}-description`,
    type: 'checkbox',
    className:
      'h-4 w-4 rounded-md border-gray-300 text-green-700 focus:ring-green-700 cursor-pointer',
    disabled,
    required,
    ...(register && name ? register(name, { required }) : {}),
  } as React.InputHTMLAttributes<HTMLInputElement>;

  if (isControlled) {
    inputProps.checked = value;
    inputProps.onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (setValue) {
        setValue(e.target.checked);
      }
    };
  } else {
    inputProps.defaultChecked = value;
  }

  return (
    <div
      className={classNames(
        'relative flex items-center',
        disabled && 'opacity-30 pointer-events-none',
        className
      )}
    >
      <div className="flex h-5 items-center">
        <input {...inputProps} />
      </div>

      <label
        htmlFor={id}
        className={classNames(
          'ml-3 text-md font-medium text-gray-700 cursor-pointer',
          labelClasses
        )}
        style={labelStyle}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    </div>
  );
};

export default CheckboxWithLabel;